import { Box, Button, CircularProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Taxi } from 'api/vehicle/taxisAPI.types';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Supplier } from '../../../../api/supplier/suppliers.types';
import { suppliersAPI } from '../../../../api/supplier/suppliersAPI';
import { taxisAPI } from '../../../../api/vehicle/taxisAPI';
import {
    useSupplierDispatch,
    useSupplierState,
} from '../../../../Pages/Supplier/SupplierContext';
import CreateTaxiHOC from './CreateTaxi.hoc';
import VehicleSummary from './VehicleSummary';

export const Taxis = () => {
  const dispatch = useSupplierDispatch()
  const [selectedTaxi, setSelectedTaxi] = useState<Taxi>()
  const { taxis } = useSupplierState()

  const supplier: Supplier = useSelector(
    (state: any) => state.suppliers.supplier,
  )
  const [newTaxi, setNewTaxi] = useState(false)
  const [newTaxiButton, setNewTaxiButton] = useState(true)
  const { refetch, isLoading } = useQuery({
    queryKey: ['getTaxis', supplier?.id],
    queryFn: async () => {
      if (supplier?.id) {
        return taxisAPI.getTaxisBySupplierId(supplier?.id)
      }
    },
    onSuccess: (data) => {
      if (data) {
        return dispatch({ type: 'setTaxis', payload: data.data.value })
      }
    },
    refetchOnWindowFocus: false,
  })

  useQuery({
    queryKey: ['getChargeExeptions', supplier.id],
    queryFn: async () => suppliersAPI.getChargeExceptions(supplier.id),
    onSuccess: (data) => {
      if (data) {
        return dispatch({
          type: 'setChargeExceptions',
          payload: data.data.value,
        })
      }
    },
    refetchOnWindowFocus: false,
  })

  const handleNewTaxiClick = () => {
    setSelectedTaxi(undefined)
    setNewTaxi(true)
    setNewTaxiButton(false)
  }
  const handleViewTaxi = (taxiId: number) => {
    const findTaxi = taxis.find((t) => t.id === taxiId)
    setSelectedTaxi(findTaxi)
    setNewTaxiButton(false)
    setNewTaxi(false)
  }
  const backToSummaryClick = () => {
    setSelectedTaxi(undefined)
    setNewTaxiButton(true)
    setNewTaxi(false)
    refetch()
  }

  const VehicleComponent = () => {
    if (newTaxi) {
      return <CreateTaxiHOC backToSummaryFunction={backToSummaryClick} />
    }
    if (selectedTaxi) {
      return (
        <CreateTaxiHOC
          taxiId={selectedTaxi.id}
          backToSummaryFunction={backToSummaryClick}
        />
      )
    }
    return (
      <VehicleSummary
        handleClick={handleViewTaxi}
        backToSummaryFunction={backToSummaryClick}
      />
    )
  }

  return (
    <Box component="div" sx={{ width: '100%', paddingRight: '50px' }}>
      {newTaxiButton && (
        <Button onClick={handleNewTaxiClick}>Add Vehicle +</Button>
      )}

      {taxis && <VehicleComponent />}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
        }}
      >
        {isLoading && <CircularProgress />}
      </Box>
    </Box>
  )
}
export default Taxis
